import axios from "axios";
import { configUrl } from "config.js";

const createUser = async (user) => {
  const payload = {
    userId: user.userId,
    userName: user.userName,
    passCode: user.passCode,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    mobileNo: user.mobileNo,
    addressLine: user.addressLine,
    dob: user.dob,
    doa: user.doa,
    doj: user.doj,
    dol: user.dol,
    active: user.active,
    isSso: user.isSso,
    ssoprovider: user.ssoprovider,
    avatar: user.avatar,
    userTypeId: user.userTypeId,
    createdBy: user.createdBy,
    createdDate: user.createdDate,
    updatedBy: user.updatedBy,
    updatedDate: new Date()
  };


  let response = await axios.post(`${configUrl.AssessmentServer}/api/User`, payload)

  return response.data

};

const updateUser = async (user) => {
  const payload = {
    userId: user.userId,
    userName: user.userName,
    passCode: user.passCode,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    mobileNo: user.mobileNo,
    addressLine: user.addressLine,
    dob: user.dob,
    doa: user.doa,
    doj: user.doj,
    dol: user.dol,
    active: user.active,
    isSso: user.isSso,
    ssoprovider: user.ssoprovider,
    avatar: user.avatar,
    userTypeId: user.userTypeId,
    createdBy: user.createdBy,
    createdDate: user.createdDate,
    updatedBy: user.updatedBy,
    updatedDate: user.updatedDate,
  };

  let response = await axios.put(`${configUrl.AssessmentServer}/api/User/${user.userId}`, payload)

  return response.data
}


const getAllUsers = async () => {
  let response = await axios.get(`${configUrl.AssessmentServer}/api/User`)

  return response.data
}

const getUserByUserName = async (userName) => {
  let response = await axios.get(`${configUrl.AssessmentServer}/api/User/Name/${userName}`)

  return response.data
}

const deleteUser = async (id) => {
  let response = await axios.delete(`${configUrl.AssessmentServer}/api/User/${id}`)
  return response.data
}

const updateLoginDate = async (id) => {
  try {

    let response = await axios.put(`${configUrl.AssessmentServer}/api/User/updateUserLastLogin/${id}`)

    return response
  } catch (e) {
    console.log("error occuredff", e);
  }
}

export default {
  createUser: createUser,
  updateUser: updateUser,
  getAllUsers: getAllUsers,
  getUserByUserName: getUserByUserName,
  updateLoginDate: updateLoginDate,
  deleteUser: deleteUser
}
